import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import useOnScreen from "../hooks/useOnScreen";

const Projects = ({ title, src, id, href, tech, desc, github }) => {
  const list = useRef();
  const [reveal, setReveal] = useState(false);
  const onScreen = useOnScreen(list);

  useEffect(() => {
    if (onScreen) setReveal(onScreen);
  }, [onScreen]);
  return (
    <>
      <motion.li ref={list} target="blank" key={id} className="link">
        <div className="banner">
          <img
            src={src}
            alt={title}
            data-scroll
            className={reveal ? "is-reveal" : ""}
          />
        </div>
        <div className="header">
          <div className={reveal ? "is-reveal caption" : "caption"}>
            {title}
          </div>
          <i
            className={
              reveal
                ? "is-reveal fas fa-external-link-square-alt"
                : "fas fa-external-link-square-alt"
            }
          ></i>
        </div>
        <div className="tags">
          <div style={{ overflow: "hidden" }}>
            <p className={reveal ? "desc is-reveal" : "desc"}>{desc}</p>
          </div>
          <div style={{ overflow: "hidden" }}>
            <span className={reveal ? "is-reveal" : ""}>
              {" "}
              <b>Tech Stack - </b>
              {tech}
            </span>
          </div>
        </div>
        <div className="work_btns">
          <a href={github} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github" title="GitHub"></i>Github
          </a>
          <a href={href} target="_blank" rel="noopener noreferrer">
            <i className="fas fa-link"></i>Live Demo
          </a>
        </div>
      </motion.li>
    </>
  );
};

export default Projects;
